import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { ConfigModule, I18nModule, UrlModule } from '@spartacus/core'
import {
  MediaModule,
  SpinnerModule,
  ListNavigationModule,
} from '@spartacus/storefront'
import { HelpService } from './help.service'
import { SiteTourElementsComponent } from './site-tour/site-tour-elements/site-tour-elements.component'
import { SiteTourComponent } from './site-tour/site-tour.component'
import { HelpMenuComponent } from './help-menu/help-menu.component'
import { FeedbackFormComponent } from './feedback/feedback-form/feedback-form.component'
import { GuestFeedbackFormComponent } from './feedback/feedback-form/guest-feedback-form/guest-feedback-form.component'
import { LoggedinFeedbackFormComponent } from './feedback/feedback-form/loggedin-feedback-form/loggedin-feedback-form.component'
import { FeedbackAttachmentsComponent } from './feedback/feedback-form/feedback-attachments/feedback-attachments.component'
import { FeedbackService } from './feedback/feedback-form/feedback.service'
import { VideoTutorComponent } from './video-tutor/video-tutor.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { environment } from '../../../environments/environment'

@NgModule({
  declarations: [
    SiteTourComponent,
    SiteTourElementsComponent,
    HelpMenuComponent,
    FeedbackFormComponent,
    GuestFeedbackFormComponent,
    LoggedinFeedbackFormComponent,
    FeedbackAttachmentsComponent,
    VideoTutorComponent,
  ],
  imports: [
    CommonModule,
    MediaModule,
    SpinnerModule,
    I18nModule,
    ReactiveFormsModule,
    ListNavigationModule,
    UrlModule,
    RouterModule,
    I18nModule,
    NgSelectModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['help'],
        },
      },
    }),
  ],
  exports: [
    SiteTourComponent,
    SiteTourElementsComponent,
    HelpMenuComponent,
    VideoTutorComponent,
  ],
  providers: [HelpService, FeedbackService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HelpModule {}
